import { render, staticRenderFns } from "./ArticleAliasesModal.vue?vue&type=template&id=6635b092&"
import script from "./ArticleAliasesModal.vue?vue&type=script&lang=js&"
export * from "./ArticleAliasesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports